export default "__VITE_ASSET__C366ibdy__"